import React, { useState, useEffect } from 'react';
import './CheckField.scss';
import HoverTip from '../hoverTip/hoverTip';
import { Icon_Check, Icon_EmptyCheckbox } from '../../../UI/screens/form/styles/assets/icons';

const CheckField = ({ checkboxType, formik, formValue, checkItemLabel, physicianFunction, allOrNone, tooltip, trueFormSpec, className, localFacilities, decorative = false, lockcheck }) => {

    const [checked, setChecked] = useState(false);

    const releaseConfig = {
        selectedItems: formik.values.infoToReleaseGroup,
        field: 'infoToReleaseGroup',
    }
    const facilityConfig = {
        selectedItems: formik.values.facilityList,
        field: 'facilityList',
    }

    const config = checkboxType === 'release' ? releaseConfig : checkboxType === 'facility' ? facilityConfig : null;

    useEffect(() => {
        if (checkboxType === 'sensitive') {
            if (formik.values.sensitiveInfo.includes(formValue)) {
                setChecked(true);
                formik.setFieldValue("InvertCheckbox_SensitiveInformation_" + formValue, false);

            } else {
                setChecked(false);
                formik.setFieldValue("InvertCheckbox_SensitiveInformation_" + formValue, true);
            }
          
        }
    }, [formik.values.sensitiveInfo]);

    useEffect(() => {
        // make list of all items in requested item list.
        if (checkboxType === 'releaseAll') {

            let infoToReleaseGroupAllShort = trueFormSpec.release.items
                .filter(item => item.key !== "otherItem").map(item => {
                    return item.key;
                });

            formik.setFieldValue("infoToReleaseGroupAll", infoToReleaseGroupAllShort);
        }
    }, []);



    useEffect(() => {
        //toggle for Release all
        if (formik.values.infoToReleaseGroupAll && checkboxType === 'releaseAll') {
            if (formik.values.infoToReleaseGroupAll.length === formik.values.infoToReleaseGroup.length) {
                setChecked(true);
            } else {
                setChecked(false);
            }
        }

        // toggle for individual checkboxes.
        if (checkboxType === 'release') {
            if (formik.values.infoToReleaseGroup.includes(formValue)) {
                setChecked(true);
            } else {
                setChecked(false);
            }
        }
    }, [formik.values.infoToReleaseGroup]);


    if (decorative) {
        return (
            <label className={`check-field2 subtitle2 check-field-decorative`} >
                <Icon_Check />
                {checkItemLabel}
            </label>
        )

    }

    function ClickHandler() {
        if (checkboxType === 'release') {
            if (config.selectedItems.includes(formValue)) {
                setChecked(false);
                formik.setFieldValue(config.field, config.selectedItems.filter((releaseItemValue) => {
                    return releaseItemValue !== formValue;
                }))
            }
            else {
                setChecked(true);
                formik.setFieldValue(config.field, [...config.selectedItems, formValue]);
            }
        }
        if (checkboxType === 'releaseAll') {
            if (checked) {
                setChecked(false);
                formik.setFieldValue("infoToReleaseGroup", []);
            } else {
                setChecked(true);
                formik.setFieldValue("infoToReleaseGroup", [...formik.values.infoToReleaseGroupAll]);
            }
        }

        else if (checkboxType === 'facility') {
            if (config.selectedItems.includes(formValue)) {
                setChecked(false);
                formik.setFieldValue(config.field, config.selectedItems.filter((releaseItemValue) => {
                    return releaseItemValue !== formValue
                }))
            }
            else {
                setChecked(true);
                formik.setFieldValue(config.field, [...config.selectedItems, formValue]);
                checkboxType === 'facility' && formik.setFieldValue('facilityOrPhysician', "on")
            }
        }

        else if (checkboxType === 'facilityTextbox') {

            if (formik.values.facilityList.includes(formValue)) {
                setChecked(false);
                formik.setFieldValue("facilityList", formik.values.facilityList.filter((releaseItemValue) => {
                    return releaseItemValue !== formValue
                }))
            }
            else {
                setChecked(true);
                formik.setFieldValue("facilityList", [...formik.values.facilityList, formValue]);
                checkboxType === 'facility' && formik.setFieldValue('facilityOrPhysician', "on");
            }
        }


        else if (checkboxType === 'selectAndTypeFacility') {
            if (checked) {
                setChecked(false);
                localFacilities.set([...localFacilities.value].filter((facility) => { return facility !== checkItemLabel }));
            }
            else {
                setChecked(true);
                !localFacilities.value.includes(checkItemLabel) && localFacilities.set([...localFacilities.value, checkItemLabel]);
            }
        }

        else if (checkboxType === 'sensitive') {
            checked ?
                formik.setFieldValue('sensitiveInfo', formik.values.sensitiveInfo.filter((info) => { return info !== formValue }))
                :
                formik.setFieldValue('sensitiveInfo', [...formik.values.sensitiveInfo.filter((item) => { return item !== 'excludeAll' }), formValue])

        }
        else if (checkboxType === 'physicians') {
            formik.values.inputAuthorizePhysicianOffices === "on" ? setChecked(false) : setChecked(true)
            formik.setFieldValue('inputAuthorizePhysicianOffices', formik.values.inputAuthorizePhysicianOffices === "on" ? "" : "on")
            formik.setFieldValue('inputDisclosePhysicians', formik.values.inputDisclosePhysicians === "on" ? "" : "on")
            formik.setFieldValue('facilityOrPhysician', formik.values.facilityOrPhysician === "on" && formik.values.facilityList.length === 0 ? "" : "on")
            checked ? physicianFunction(false) : physicianFunction(true)
            checked ? formik.setFieldValue('inputPhysicianNames', 'not_applicable') : formik.setFieldValue('inputPhysicianNames', '')
        }
        else {

        }
    }
    return (<div>
        <label className={`check-field2 subtitle2`}>
            {checked ? <Icon_Check /> : <Icon_EmptyCheckbox />}
            {checkItemLabel}
            {/* The system was built where the text is the ID.  Sensitive info cannot be that way. */}
            {(checkboxType === 'sensitive') ? <input onClick={() => { ClickHandler() }} className={`input-test visually-hidden ${className}`} type="checkbox" id={formValue} disabled={lockcheck ? 'disabled' : null} /> :
                <input onClick={() => { ClickHandler() }} className={`input-test visually-hidden ${className}`} type="checkbox" id={checkItemLabel} />}
            {/* <label className='check-test check-field2' htmlFor={checkItemLabel}>{checkItemLabel}</label> */}
            {(checkboxType === 'release' || tooltip) && <span onClick={(e) => { e.stopPropagation() }}><HoverTip popverLocation={null} tooltip={tooltip} /></span>}
        </label>

    </div>

    )
}

export default CheckField;


const UnCheckedBox = () => {
    return (
        <svg width="23" className='checkbox' height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="21" height="21" rx="3" fill="#FDFDFD" stroke="#B3B3B3" stroke-width="2" />
        </svg>
    )
}

const CheckedBox = () => {
    return (
        <svg width="23" className='checkbox' height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="21" height="21" rx="3" fill="#3A546E" stroke="#3A546E" stroke-width="2" />
            <path d="M6 11L10.5 15.5L18 6.5" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )

}